import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "kind", "settings", "cheatsheet", "flash",
    "imagesRow", "colLeft", "colMiddle", "colRight",
    "bodyRow", "bodyLeft", "bodyMiddle", "bodyRight", "bodyFourth", "bodyLeftLabel",
    "tabBtn", "tabPanel", "exampleJson"
  ]

  connect() {
    this.renderCheatsheet()
    this.renderExampleJson()
    this.updateColumnVisibility()
  }

  kindChanged() {
    this.renderCheatsheet()
    this.renderExampleJson()
    this.updateColumnVisibility()
  }

  showTab(event) {
    const tab = event.currentTarget.dataset.tab

    // Update tab buttons
    this.tabBtnTargets.forEach(btn => {
      if (btn.dataset.tab === tab) {
        btn.style.background = "white"
        btn.style.color = "inherit"
        btn.style.borderBottom = "2px solid #0f172a"
      } else {
        btn.style.background = "transparent"
        btn.style.color = "#64748b"
        btn.style.borderBottom = "2px solid transparent"
      }
    })

    // Update tab panels
    this.tabPanelTargets.forEach(panel => {
      panel.style.display = panel.dataset.tab === tab ? "block" : "none"
    })
  }

  renderExampleJson() {
    const ex = this.exampleForCurrentKind()
    if (this.hasExampleJsonTarget) {
      if (ex) {
        this.exampleJsonTarget.textContent = JSON.stringify(ex.example, null, 2)
      } else {
        this.exampleJsonTarget.textContent = "No example available for this section type."
      }
    }
  }

  updateColumnVisibility() {
    const kind = this.kindTarget.value

    // Sections that use a single image
    const singleImageSections = [
      "parallax_header", "hero_video", "hero_img", "why_split", "contact_split", "text", "three_row"
    ]

    // Sections that use no images (JSON-based content)
    const noImageSections = [
      "section_header", "text_center", "features_three_col", "gallery", "three_flyin", "vortex_images", "hero_slides", "contact_form"
    ]

    // Hide fourth body by default
    if (this.hasBodyFourthTarget) {
      this.bodyFourthTarget.style.display = "none"
    }

    if (kind === "cube_teaser") {
      // 4 Trix-Editoren für Item-Texte (1–4)
      this.imagesRowTarget.style.display = "none"
      this.bodyRowTarget.style.gridTemplateColumns = "1fr"
      this.bodyLeftTarget.style.display = "block"
      this.bodyMiddleTarget.style.display = "block"
      this.bodyRightTarget.style.display = "block"
      if (this.hasBodyFourthTarget) this.bodyFourthTarget.style.display = "block"
      this.bodyLeftLabelTarget.textContent = "Item 1: Text"
      this.bodyMiddleTarget.querySelector("label").textContent = "Item 2: Text"
      this.bodyRightTarget.querySelector("label").textContent = "Item 3: Text"
      if (this.hasBodyFourthTarget) this.bodyFourthTarget.querySelector("label").textContent = "Item 4: Text"
    } else if (kind === "accordion_tabs_section") {
      // Show all four body columns for accordion tabs
      this.imagesRowTarget.style.display = "none"

      this.bodyRowTarget.style.gridTemplateColumns = "1fr"
      this.bodyLeftTarget.style.display = "block"
      this.bodyMiddleTarget.style.display = "block"
      this.bodyRightTarget.style.display = "block"
      if (this.hasBodyFourthTarget) {
        this.bodyFourthTarget.style.display = "block"
      }
      this.bodyLeftLabelTarget.textContent = "Tab 1: SEARCH"
      this.bodyMiddleTarget.querySelector("label").textContent = "Tab 2: APPLY"
      this.bodyRightTarget.querySelector("label").textContent = "Tab 3: CREATE"
      if (this.hasBodyFourthTarget) {
        this.bodyFourthTarget.querySelector("label").textContent = "Tab 4: CONNECT"
      }
    } else if (kind === "three_row") {
      // Three stacked rows, no images (background image on section level)
      this.imagesRowTarget.style.display = "none"

      this.bodyRowTarget.style.gridTemplateColumns = "1fr"
      this.bodyLeftTarget.style.display = "block"
      this.bodyMiddleTarget.style.display = "block"
      this.bodyRightTarget.style.display = "block"
      this.bodyLeftLabelTarget.textContent = "Body (Zeile 1)"
      this.bodyMiddleTarget.querySelector("label").textContent = "Body (Zeile 2)"
      this.bodyRightTarget.querySelector("label").textContent = "Body (Zeile 3)"
    } else if (kind === "grid_two_by_two") {
      // 2×2 grid, four body editors, no images
      this.imagesRowTarget.style.display = "none"

      this.bodyRowTarget.style.gridTemplateColumns = "1fr"
      this.bodyLeftTarget.style.display = "block"
      this.bodyMiddleTarget.style.display = "block"
      this.bodyRightTarget.style.display = "block"
      if (this.hasBodyFourthTarget) this.bodyFourthTarget.style.display = "block"
      this.bodyLeftLabelTarget.textContent = "Body (Zelle 1 – oben links)"
      this.bodyMiddleTarget.querySelector("label").textContent = "Body (Zelle 2 – oben rechts)"
      this.bodyRightTarget.querySelector("label").textContent = "Body (Zelle 3 – unten links)"
      if (this.hasBodyFourthTarget) this.bodyFourthTarget.querySelector("label").textContent = "Body (Zelle 4 – unten rechts)"
    } else if (kind === "three_col") {
      // Show all three columns
      this.imagesRowTarget.style.display = "grid"
      this.imagesRowTarget.style.gridTemplateColumns = "1fr 1fr 1fr"
      this.colLeftTarget.style.display = "block"
      this.colMiddleTarget.style.display = "block"
      this.colRightTarget.style.display = "block"

      this.bodyRowTarget.style.gridTemplateColumns = "1fr"
      this.bodyLeftTarget.style.display = "block"
      this.bodyMiddleTarget.style.display = "block"
      this.bodyRightTarget.style.display = "block"
      this.bodyLeftLabelTarget.textContent = "Body (Left)"
      this.bodyMiddleTarget.querySelector("label").textContent = "Body (Middle)"
      this.bodyRightTarget.querySelector("label").textContent = "Body (Right)"
    } else if (kind === "two_col") {
      // Show left and right columns
      this.imagesRowTarget.style.display = "grid"
      this.imagesRowTarget.style.gridTemplateColumns = "1fr 1fr"
      this.colLeftTarget.style.display = "block"
      this.colMiddleTarget.style.display = "none"
      this.colRightTarget.style.display = "block"

      this.bodyRowTarget.style.gridTemplateColumns = "1fr"
      this.bodyLeftTarget.style.display = "block"
      this.bodyMiddleTarget.style.display = "none"
      this.bodyRightTarget.style.display = "block"
      this.bodyLeftLabelTarget.textContent = "Body (Left)"
      this.bodyRightTarget.querySelector("label").textContent = "Body (Right)"
    } else if (singleImageSections.includes(kind)) {
      // Show single image upload only
      this.imagesRowTarget.style.display = "grid"
      this.imagesRowTarget.style.gridTemplateColumns = "1fr"
      this.colLeftTarget.style.display = "block"
      this.colMiddleTarget.style.display = "none"
      this.colRightTarget.style.display = "none"

      this.bodyRowTarget.style.gridTemplateColumns = "1fr"
      this.bodyLeftTarget.style.display = "block"
      this.bodyMiddleTarget.style.display = "none"
      this.bodyRightTarget.style.display = "none"
      this.bodyLeftLabelTarget.textContent = "Body"
    } else {
      // No image, only body (single column)
      this.imagesRowTarget.style.display = "none"

      this.bodyRowTarget.style.gridTemplateColumns = "1fr"
      this.bodyLeftTarget.style.display = "block"
      this.bodyMiddleTarget.style.display = "none"
      this.bodyRightTarget.style.display = "none"
      this.bodyLeftLabelTarget.textContent = "Body"
    }
  }

  copyExample() {
    const ex = this.exampleForCurrentKind()
    if (!ex) return

    const json = JSON.stringify(ex.example, null, 2)
    navigator.clipboard
      .writeText(json)
      .then(() => this.toast("Example JSON copied."))
      .catch(() => this.toast("Copy failed (browser permission)."))
  }

  applyExample() {
    const ex = this.exampleForCurrentKind()
    if (!ex) return

    const ok = confirm("Replace Settings JSON with the example for this template?")
    if (!ok) return

    this.settingsTarget.value = JSON.stringify(ex.example, null, 2)
    this.settingsTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.settingsTarget.focus()
    this.toast("Example JSON applied.")
  }

  validateJson() {
    const txt = (this.settingsTarget.value || "").trim()
    if (!txt) {
      this.toast("Settings JSON is empty (valid).")
      return
    }

    try {
      JSON.parse(txt)
      this.toast("JSON is valid.")
    } catch (e) {
      this.toast("Invalid JSON: " + this.humanJsonError(e))
    }
  }

  formatJson() {
    const txt = (this.settingsTarget.value || "").trim()
    if (!txt) {
      this.toast("Nothing to format.")
      return
    }

    try {
      const obj = JSON.parse(txt)
      this.settingsTarget.value = JSON.stringify(obj, null, 2)
      this.settingsTarget.dispatchEvent(new Event("input", { bubbles: true }))
      this.settingsTarget.focus()
      this.toast("JSON formatted.")
    } catch (e) {
      this.toast("Cannot format: " + this.humanJsonError(e))
    }
  }

  renderCheatsheet() {
    const ex = this.exampleForCurrentKind()
    if (!ex) {
      this.cheatsheetTarget.innerHTML = '<p class="text-sm text-slate-500">No cheatsheet available for this section type.</p>'
      return
    }

    const keysHtml = ex.keys.map((k) => "<li>" + this.escapeHtml(k) + "</li>").join("")

    this.cheatsheetTarget.innerHTML =
      '<div>' +
        '<div class="flex items-center justify-between mb-3">' +
          '<p class="text-sm font-semibold text-slate-900">Expected Keys</p>' +
          '<span class="rounded-full bg-slate-200 px-2 py-1 text-xs text-slate-700">' + this.escapeHtml(this.kindTarget.value) + '</span>' +
        '</div>' +
        '<ul class="list-disc pl-5 text-sm text-slate-600 space-y-1">' +
          keysHtml +
        '</ul>' +
      '</div>'
  }

  exampleForCurrentKind() {
    const kind = this.kindTarget.value
    return this.examples()[kind] || null
  }

  examples() {
    return {
      text_center: {
        keys: [
          "title",
          "subtitle (optional)",
          "subtitle_typed (optional, Pipe-getrennte Wörter z.B. 'Zukunft|Erfolg|Wachstum')",
          "theme (white, light, dark - default white)",
          "container (contained, narrow, full - default contained)",
          "animation (fade-in-up, fade-in-down, scale-in, none - default fade-in-up)",
          "padding_top (rem, default 4)",
          "padding_bottom (rem, default 4)",
          "button_text (1. Button-Beschriftung, optional)",
          "button_link (1. Button-Ziel-URL, optional)",
          "button2_text (2. Button-Beschriftung, optional)",
          "button2_link (2. Button-Ziel-URL, optional)",
          "Body: Main text content (Action Text)"
        ],
        example: {
          title: "Unsere Vision",
          subtitle: "Was uns antreibt: ",
          subtitle_typed: "Zukunft|Erfolg|Wachstum",
          theme: "white",
          container: "contained",
          animation: "fade-in-up",
          padding_top: "4",
          padding_bottom: "4",
          button_text: "Mehr erfahren",
          button_link: "/features",
          button2_text: "Jetzt starten",
          button2_link: "/kontakt"
        },
      },
      why_split: {
        keys: [
          "title",
          "subtitle",
          "quote",
          "quote_cta",
          "image_alt",
          "animation (fade-in-up, fade-in-down, scale-in, none - default fade-in-up)"
        ],
        example: {
          title: "inside knowledge economies",
          subtitle: "Wissen ist ein entscheidender Wertschöpfungsfaktor.",
          quote: "Wissensträger sind das höchste Gut eines Unternehmens.",
          quote_cta: "Werden Sie als Experte sichtbar!",
          image_alt: "Team at work",
          animation: "fade-in-up"
        },
      },
      parallax_header: {
        keys: [
          "title",
          "subtitle (optional)",
          "subtitle_typed (optional, Pipe-getrennte Wörter z.B. 'Zukunft|Erfolg|Wachstum')",
          "image_alt",
          "padding_top (rem, default 4)",
          "padding_bottom (rem, default 4)",
          "animation (fade-in-up, fade-in-down, scale-in - default fade-in-up)",
          "button_text (optional)",
          "button_link (optional)"
        ],
        example: {
          title: "inside key features",
          subtitle: "Search - Apply - Create - Connect",
          image_alt: "Background",
          padding_top: "4",
          padding_bottom: "4",
          animation: "fade-in-up",
          button_text: "Mehr erfahren",
          button_link: "/de/features"
        },
      },
      features_three_col: {
        keys: [
          "items (Array of 3)",
          "items[].icon (lightbulb|target|teamwork)",
          "items[].title",
          "items[].kicker",
          "items[].lead",
          "items[].bullets (Array of strings; supports <b>, <sup>)",
          "items[].bullet_style (dot, check, empty, cross - default dot)",
          "items[].note (optional)",
          "bg_color (white, light, dark - default white)",
          "container (contained, full - default contained)",
          "animation (fade-in-up, fade-in-down, scale-in, none - default fade-in-up)",
          "padding_top (rem, default 2.5)",
          "padding_bottom (rem, default 2.5)"
        ],
        example: {
          items: [
            {
              icon: "lightbulb",
              title: "Single Source of Truth",
              kicker: "Share it!",
              lead: "Zur Vermeidung von Datensilos stehen für alle dieselben gesicherten Informationen als Arbeits- und Entscheidungsgrundlagen zur Verfügung.",
              bullets: [
                "<b>Beiträge</b> sind in den Themenbereichen einer Domain verortet und geben Auffassungen und Erfahrungen der jeweiligen Autor:innen und Teams wieder.",
                "<b>Grundlagen</b> (Dictionaries, Events, Maps usw.) stehen als Fakten für sich. Verweise dienen in Beiträgen dem Verständnis und der Vertiefung.",
                "<b>Quellen</b> (Dateien, Bibliotheken, interne/externe Links) dienen als Referenz und Nachweis."
              ],
              bullet_style: "dot"
            },
            {
              icon: "target",
              title: "Relevant Search",
              kicker: "Gibt es Ansprechpartner?",
              lead: "Im Ergebnis einer Suche werden nicht nur Beiträge, Grundlagen und Quellen, sondern auch Expert:innen zum Thema sichtbar. Weitere Optionen:",
              bullets: [
                "Anhand von dedizierten <b>Filterfunktionen</b> lassen sich Suchergebnisse schrittweise verfeinern.",
                "<b>Feature Sets</b> <sup>[1]</sup> können bei Suche und Auswertung herangezogen werden.",
                "Speicherbare <b>Hitlisten</b> unterstützen die Recherche und ermöglichen eine nachträgliche Auswertung."
              ],
              note: "[1] <b>Feature Sets</b> sind dynamische Metadatenobjekte zur Klassifizierung von Inhalten. Sie ermöglichen z. B. die Anbindung von Machine-Learning-Verfahren und die Nutzung als Datenbasis für KI-Anwendungen."
            },
            {
              icon: "teamwork",
              title: "Social Communities",
              kicker: "Central Points of Communication.",
              lead: "Kommunikation dokumentiert Entstehungsprozesse und zählt in Form von Feedback und Kommentaren direkt zum Informationsgehalt der Inhalte <sup>[2]</sup>.",
              bullets: [
                "<b>Redaktionelle Workflows</b> dienen der Prüfung und Freigabe von Inhalten.",
                "<b>Foren</b> fördern Diskussionen und treiben die Weiterentwicklung von Beiträgen.",
                "<b>News</b> (Verweise auf Inhalte) stärken den Informationsfluss im Team.",
                "<b>Follower</b> werden über neue Inhalte und Änderungen informiert.",
                "<b>Team Chat</b> und <b>Messenger</b> halten Kommunikation und Zusammenarbeit im Alltag aufrecht."
              ],
              note: "[2] Collaboration-Funktionen helfen Teams, Datenschutz und Informationszugang im Rahmen der DSGVO eigenverantwortlich zu gestalten."
            }
          ],
          bg_color: "white",
          container: "contained",
          animation: "fade-in-up",
          padding_top: "2.5",
          padding_bottom: "2.5"
        }
      },
      contact_form: {
        keys: [
          "title (optional)",
          "subtitle (optional)",
          "bg_color (white, light, dark - default white)",
          "container (contained, narrow, full - default narrow)",
          "animation (fade-in-up, fade-in-down, scale-in, none - default fade-in-up)"
        ],
        example: {
          title: "Kontaktieren Sie uns",
          subtitle: "Wir melden uns innerhalb von 24 Stunden.",
          bg_color: "light",
          container: "narrow",
          animation: "fade-in-up"
        }
      },
      contact_split: {
        keys: [
          "title",
          "image_alt",
          "blocks (Array of {headline,phone,email})",
          "animation (fade-in-up, fade-in-down, scale-in, none - default fade-in-up)"
        ],
        example: {
          title: "contact",
          image_alt: "Contact",
          blocks: [
            { headline: "Anfragen / Vertrieb", phone: "+49 89 2096-1724", email: "info@inside-workspace.de" },
            { headline: "Hotline / Technischer Support", phone: "+49 89 2096-2816", email: "support@inside-workspace.de" },
          ],
          animation: "fade-in-up"
        },
      },
      hero_img: {
        keys: [
          "title",
          "subtitle (optional)",
          "text_color (white, light, dark - default white)",
          "body_size (small, medium, large - default medium)",
          "animation (fade-in-up, fade-in-down, scale-in - default fade-in-up)",
          "overlay (0.0 – 1.0, Dunkel-Overlay über Bild - default 0.4)"
        ],
        example: {
          title: "Dein Titel hier",
          subtitle: "Kurzer Untertitel",
          text_color: "white",
          body_size: "medium",
          animation: "fade-in-up",
          overlay: 0.4
        },
      },
      hero_video: {
        keys: [
          "title",
          "subtitle (optional)",
          "subtitle_typed (optional, Pipe-getrennte Wörter z.B. 'Zukunft|Erfolg|Wachstum')",
          "button_text (optional)",
          "video_url (optional, default: /videos/ai-animo.mp4)",
          "text_color (white, light, dark - default white)",
          "body_size (small, medium, large - default medium)",
          "animation (fade-in-up, fade-in-down, scale-in - default fade-in-up)"
        ],
        example: {
          title: "Vielleicht kennst du das Gefühl ...",
          subtitle: "Wissen ist da. Aber es wirkt nicht. Noch nicht.",
          button_text: "Scroll weiter",
          video_url: "/videos/ai-animo.mp4",
          text_color: "white",
          body_size: "medium",
          animation: "fade-in-up"
        },
      },
      section_header: {
        keys: [
          "title",
          "subtitle (optional)",
          "subtitle_typed (optional, Pipe-getrennte Wörter z.B. 'Zukunft|Erfolg|Wachstum')",
          "bg_color (white, light, dark)",
          "size (small, medium, large)",
          "animation (fade-in-up, fade-in-down, scale-in, none - default fade-in-up)"
        ],
        example: {
          title: "Unsere Features",
          subtitle: "Was uns besonders macht",
          bg_color: "white",
          size: "medium",
          animation: "fade-in-up"
        },
      },
      two_col: {
        keys: [
          "title_top (optional, type-title, zentriert)",
          "subtitle_top (optional, type-subtitle, zentriert)",
          "alignment_top (left, center - default center)",
          "title_left (optional, type-title - gleicher Style wie title_top)",
          "title_right (optional, type-title - gleicher Style wie title_top)",
          "image_left_position (before, after - default before)",
          "image_right_position (before, after - default before)",
          "image_left_alt",
          "image_right_alt",
          "image_style (rounded, full - default rounded)",
          "col_width (50-50, 60-40, 40-60, 70-30, 30-70)",
          "bg_color (white, light, dark)",
          "vertical_align (top, center, bottom)",
          "container (contained, full - default contained)",
          "border (none, border, divider - default none)",
          "animation (fade-in-up, slide-in-left, slide-in-right, none - default fade-in-up)",
          "padding_top (rem, default 4)",
          "padding_bottom (rem, default 4)",
          "button_left_text (optional)",
          "button_left_url (optional)",
          "button_right_text (optional)",
          "button_right_url (optional)"
        ],
        example: {
          title_top: "Überschrift oben",
          subtitle_top: "Optionaler Untertitel",
          alignment_top: "center",
          title_left: "Linke Spalte",
          title_right: "Rechte Spalte",
          image_left_position: "before",
          image_right_position: "after",
          image_left_alt: "Bild links",
          image_right_alt: "Bild rechts",
          image_style: "rounded",
          col_width: "50-50",
          bg_color: "white",
          vertical_align: "top",
          container: "contained",
          border: "none",
          animation: "fade-in-up",
          padding_top: "4",
          padding_bottom: "4",
          button_left_text: "Mehr erfahren",
          button_left_url: "/seite",
          button_right_text: "Kontakt",
          button_right_url: "/contact"
        },
      },
      three_col: {
        keys: [
          "title_top (optional)",
          "subtitle_top (optional)",
          "title_left (optional)",
          "title_middle (optional)",
          "title_right (optional)",
          "image_left_position (before, after - default before)",
          "image_middle_position (before, after - default before)",
          "image_right_position (before, after - default before)",
          "image_left_alt",
          "image_middle_alt",
          "image_right_alt",
          "image_style (rounded, full - default rounded)",
          "bg_color (white, light, dark)",
          "vertical_align (top, center, bottom)",
          "container (contained, full - default contained)",
          "border (none, border, divider - default none)",
          "animation (fade-in-up, scale-in, none - default fade-in-up)",
          "padding_top (rem, default 4)",
          "padding_bottom (rem, default 4)",
          "button_left_text (optional)",
          "button_left_url (optional)",
          "button_middle_text (optional)",
          "button_middle_url (optional)",
          "button_right_text (optional)",
          "button_right_url (optional)"
        ],
        example: {
          title_top: "Überschrift oben",
          subtitle_top: "Optionaler Untertitel",
          title_left: "Linke Spalte",
          title_middle: "Mittlere Spalte",
          title_right: "Rechte Spalte",
          image_left_position: "before",
          image_middle_position: "before",
          image_right_position: "before",
          image_left_alt: "Bild links",
          image_middle_alt: "Bild mitte",
          image_right_alt: "Bild rechts",
          image_style: "rounded",
          bg_color: "white",
          vertical_align: "top",
          container: "contained",
          border: "none",
          animation: "fade-in-up",
          padding_top: "4",
          padding_bottom: "4",
          button_left_text: "Mehr erfahren",
          button_left_url: "/seite",
          button_middle_text: "Details",
          button_middle_url: "/seite",
          button_right_text: "Kontakt",
          button_right_url: "/contact"
        },
      },
      gallery: {
        keys: [
          "title (optional)",
          "subtitle (optional)",
          "items (Array of gallery elements)",
          "items[].image (required - image URL or path)",
          "scroll_speed (Sekunden pro Durchlauf, default 30)",
          "img_w (Bildbreite in px, default 240)",
          "item_gap (Abstand zwischen Bildern in px, default 8)",
          "bg_color (white, light, dark - default dark)",
          "container (contained, narrow, full - default contained)",
          "padding_top (rem, default 4)",
          "padding_bottom (rem, default 4)",
          "pause_on_hover (true/false, default true)",
          "track_link (URL - gesamter Track als Link, optional)",
          "button_text (optional)",
          "button_url (optional)",
          "button_align (left, center - default center)"
        ],
        example: {
          title: "Galerie",
          subtitle: "Einblicke in unsere Arbeit",
          items: [
            { image: "/images/gallery/photo1.jpg" },
            { image: "/images/gallery/photo2.jpg" },
            { image: "/images/gallery/photo3.jpg" },
            { image: "/images/gallery/photo4.jpg" }
          ],
          scroll_speed: 30,
          img_w: 240,
          item_gap: 8,
          bg_color: "dark",
          container: "contained",
          padding_top: "4",
          padding_bottom: "4",
          pause_on_hover: true,
          track_link: "/features"
        },
      },
      cta_section: {
        keys: [
          "title (optional)",
          "subtitle (optional)",
          "button_text (optional, default: Kontakt)",
          "bg_color (white, light, dark - default white)",
          "align (left, center, right - default center)",
          "padding_top (rem, default 4)",
          "padding_bottom (rem, default 4)",
          "Body: Zusätzlicher Text (optional)"
        ],
        example: {
          title: "Kontaktieren Sie uns",
          subtitle: "Wir freuen uns auf Ihre Nachricht.",
          button_text: "Jetzt anfragen",
          bg_color: "white",
          align: "center",
          padding_top: "4",
          padding_bottom: "4"
        },
      },
      three_row: {
        keys: [
          "bg_color (white, light, dark - default white)",
          "align (left, center, right - default left)",
          "container (contained, narrow, full - default contained)",
          "animation (fade-in-up, fade-in-down, scale-in, none - default fade-in-up)",
          "divider (true - Trennlinie zwischen Zeilen, default false)",
          "row_gap (rem, Abstand zwischen den Zeilen, default 3)",
          "padding_top (rem, default 4)",
          "padding_bottom (rem, default 4)",
          "bg_svg (optional, Pfad relativ zu /public/)",
          "bg_svg_opacity (optional, 0.0–1.0, default 1.0)",
          "title_1, subtitle_1, button_1_text, button_1_url → Body (Zeile 1)",
          "title_2, subtitle_2, button_2_text, button_2_url → Body Middle (Zeile 2)",
          "title_3, subtitle_3, button_3_text, button_3_url → Body Right (Zeile 3)"
        ],
        example: {
          bg_color: "dark",
          align: "left",
          container: "contained",
          animation: "fade-in-up",
          divider: "true",
          row_gap: "3",
          padding_top: "4",
          padding_bottom: "4",
          bg_svg: "",
          bg_svg_opacity: 1.0,
          title_1: "Zeile 1 Überschrift",
          subtitle_1: "Optionaler Untertitel",
          button_1_text: "Mehr erfahren",
          button_1_url: "/seite-1",
          title_2: "Zeile 2 Überschrift",
          subtitle_2: "Optionaler Untertitel",
          button_2_text: "Entdecken",
          button_2_url: "/seite-2",
          title_3: "Zeile 3 Überschrift",
          subtitle_3: "Optionaler Untertitel",
          button_3_text: "Kontakt",
          button_3_url: "/kontakt"
        },
      },
      grid_two_by_two: {
        keys: [
          "bg_color (white, light, dark - default white)",
          "align (left, center - default left)",
          "container (contained, narrow, full - default contained)",
          "animation (fade-in-up, scale-in, none - default fade-in-up)",
          "card_style (none, border, shadow - default border)",
          "padding_top (rem, default 4)",
          "padding_bottom (rem, default 4)",
          "gap (rem, Abstand zwischen den Zellen, default 2)",
          "title_top (optional, Überschrift über dem Grid)",
          "subtitle_top (optional)",
          "title_1, subtitle_1, button_1_text, button_1_url → Body (Zelle 1 – oben links)",
          "title_2, subtitle_2, button_2_text, button_2_url → Body Middle (Zelle 2 – oben rechts)",
          "title_3, subtitle_3, button_3_text, button_3_url → Body Right (Zelle 3 – unten links)",
          "title_4, subtitle_4, button_4_text, button_4_url → Body Fourth (Zelle 4 – unten rechts)"
        ],
        example: {
          bg_color: "white",
          align: "left",
          container: "contained",
          animation: "fade-in-up",
          card_style: "border",
          padding_top: "4",
          padding_bottom: "4",
          gap: "2",
          title_top: "Optionale Überschrift",
          subtitle_top: "Optionaler Untertitel",
          title_1: "Zelle 1",
          subtitle_1: "Untertitel",
          button_1_text: "Mehr",
          button_1_url: "/seite",
          title_2: "Zelle 2",
          subtitle_2: "Untertitel",
          button_2_text: "Mehr",
          button_2_url: "/seite",
          title_3: "Zelle 3",
          subtitle_3: "Untertitel",
          button_3_text: "Mehr",
          button_3_url: "/seite",
          title_4: "Zelle 4",
          subtitle_4: "Untertitel",
          button_4_text: "Mehr",
          button_4_url: "/seite"
        },
      },
      text: {
        keys: [
          "title (optional)",
          "subtitle (optional)",
          "subtitle_typed (optional, Pipe-getrennte Wörter z.B. 'Zukunft|Erfolg|Wachstum')",
          "bg_color (white, light, dark - default white)",
          "align (left, center, right - default left)",
          "container (contained, narrow, full - default contained)",
          "width (optional, % z.B. 50, 60, 75 – Textbreite innerhalb des Containers)",
          "animation (fade-in-up, fade-in-down, scale-in, none - default fade-in-up)",
          "button_text (1. Button-Beschriftung, optional)",
          "button_link (1. Button-Ziel-URL, optional)",
          "button2_text (2. Button-Beschriftung, optional)",
          "button2_link (2. Button-Ziel-URL, optional)",
          "bg_svg (optional, Pfad relativ zu /public/, z.B. 'images/deco.svg')",
          "bg_svg_opacity (optional, 0.0–1.0, default 1.0)",
          "padding_top (rem, default 4)",
          "padding_bottom (rem, default 4)",
          "Image: Hintergrundbild (optional, über Image-Upload)",
          "Body: Haupttext (ActionText)"
        ],
        example: {
          title: "Unsere Vision",
          subtitle: "Was uns antreibt: ",
          subtitle_typed: "Zukunft|Erfolg|Wachstum",
          bg_color: "dark",
          align: "left",
          container: "contained",
          width: "60",
          animation: "fade-in-up",
          button_text: "Mehr erfahren",
          button_link: "/features",
          button2_text: "Jetzt starten",
          button2_link: "/kontakt",
          bg_svg: "images/deco.svg",
          bg_svg_opacity: 0.8,
          padding_top: "4",
          padding_bottom: "4"
        },
      },
      cube_teaser: {
        keys: [
          "title (Überschrift über dem Grid, optional)",
          "subtitle (Untertitel über dem Grid, optional)",
          "items (Array von 2–4 Objekten)",
          "items[].title",
          "items[].text",
          "items[].image_url (optional, z.B. '/images/face1.jpg')",
          "items[].button_text (Button-Beschriftung, optional)",
          "items[].button_link (Button-Ziel-URL, optional)",
          "duration (ms zwischen Rotationen, default 3500)",
          "bg_color (white, light, dark – default white)",
          "animation (fade-in-up, fade-in-down, scale-in, none – default none)",
          "container (contained, narrow, full – default contained)",
          "cube_size (Breite Würfel-Spalte, default '280px')",
          "text_max (max. Breite Textspalte, default '600px', z.B. '400px')",
          "padding_top (rem, default 5)",
          "padding_bottom (rem, default 5)"
        ],
        example: {
          title: "Unsere Features",
          subtitle: "Was uns besonders macht",
          items: [
            { title: "Feature 1", text: "Beschreibungstext für Feature 1. Erkläre den Nutzen in 2–3 Sätzen.", image_url: "/images/cube/face1.jpg", button_text: "Mehr erfahren", button_link: "/feature-1" },
            { title: "Feature 2", text: "Beschreibungstext für Feature 2. Erkläre den Nutzen in 2–3 Sätzen.", image_url: "/images/cube/face2.jpg", button_text: "Mehr erfahren", button_link: "/feature-2" },
            { title: "Feature 3", text: "Beschreibungstext für Feature 3. Erkläre den Nutzen in 2–3 Sätzen.", image_url: "/images/cube/face3.jpg", button_text: "Mehr erfahren", button_link: "/feature-3" },
            { title: "Feature 4", text: "Beschreibungstext für Feature 4. Erkläre den Nutzen in 2–3 Sätzen.", image_url: "/images/cube/face4.jpg", button_text: "Mehr erfahren", button_link: "/feature-4" }
          ],
          duration: 7000,
          bg_color: "white",
          animation: "none",
          container: "contained",
          padding_top: "5",
          padding_bottom: "5"
        }
      },
      three_flyin: {
        keys: [
          "title",
          "subtitle",
          "items (Array von 3 Objekten)",
          "items[].header",
          "items[].subtext",
          "stagger (ms zwischen Subtexten, default 350)",
          "bg_color (white, light, dark – default white)",
          "padding_top (rem, default 5)",
          "padding_bottom (rem, default 5)"
        ],
        example: {
          title: "Was uns antreibt",
          subtitle: "Drei Prinzipien, die unsere Arbeit leiten.",
          items: [
            { header: "Klarheit vor Komplexität", subtext: "Wir glauben, dass gute Lösungen einfach sind – nicht simpel. Komplexität ist ein Zeichen, dass wir noch nicht fertig gedacht haben." },
            { header: "Menschen im Mittelpunkt", subtext: "Technologie ist kein Selbstzweck. Sie entfaltet ihren Wert nur, wenn sie das Leben der Menschen wirklich besser macht." },
            { header: "Langfristig denken", subtext: "Wir bauen für die Zukunft. Das bedeutet manchmal, kurzfristige Abkürzungen zu meiden – und dafür auf solide Fundamente zu setzen." }
          ],
          stagger: 350,
          bg_color: "white",
          padding_top: "5",
          padding_bottom: "5"
        }
      },
      hero_slides: {
        keys: [
          "logo_url (URL zum Logo-Bild, optional)",
          "logo_width (Breite des Logos in px, default 160)",
          "logo_height (Höhe des Logos in px, optional – überschreibt logo_width)",
          "logo_gap_top (Abstand über dem Logo in rem, default 0)",
          "logo_gap_bottom (Abstand unter dem Logo in rem, default 1.25)",
          "title (Hero-Überschrift)",
          "subtitle (Untertitel, optional)",
          "subtitle_typed (getippter Wechseltext, z.B. 'Wissen|Teams|Erfolg')",
          "button_text, button_link (optional)",
          "images (Array von URLs, empfohlen 6–8 Bilder, je 3–4 pro Spalte)",
          "bg_color (white, light, dark – default white)",
          "lane_tilt (Kippwinkel CW in Grad, default 35)",
          "img_w (Bildbreite px, default 200)",
          "img_gap (Abstand zwischen Bildern in px, negativ = Überlappung, default 8)",
          "scroll_speed (Sekunden pro Durchlauf Lane 1, default 25 – Lane 2 läuft 1.4× langsamer)",
          "padding_top (Innenabstand oben in rem, default 5)",
          "padding_bottom (Innenabstand unten in rem, default 5)",
          "margin_top (Außenabstand oben in rem, optional)",
          "margin_bottom (Außenabstand unten in rem, optional)",
          "lane1_top (Spalte 1: top in px, default -100)",
          "lane1_left (Spalte 1: px rechts von Viewport-Mitte, default 240)",
          "lane2_top (Spalte 2: top in px, default -30)",
          "lane2_left (Spalte 2: px rechts von Viewport-Mitte, default 520)"
        ],
        example: {
          logo_url: "/images/logo.svg",
          logo_width: 160,
          logo_height: "",
          logo_gap_top: 0,
          logo_gap_bottom: 1.25,
          title: "inside\nWissensmanagement",
          subtitle: "",
          subtitle_typed: "SEARCH|APPLY|CREATE|CONNECT",
          button_text: "GET IN TOUCH →",
          button_link: "/kontakt",
          images: [
            "/images/slides/s1.jpg", "/images/slides/s2.jpg", "/images/slides/s3.jpg",
            "/images/slides/s4.jpg", "/images/slides/s5.jpg", "/images/slides/s6.jpg",
            "/images/slides/s7.jpg", "/images/slides/s8.jpg", "/images/slides/s9.jpg"
          ],
          bg_color: "white",
          lane_tilt: 35,
          img_w: 200,
          img_gap: 8,
          scroll_speed: 25,
          padding_top: 5,
          padding_bottom: 5,
          margin_top: "",
          margin_bottom: "",
          lane1_top: -100,
          lane1_left: 240,
          lane2_top: -30,
          lane2_left: 520
        }
      },
      vortex_images: {
        keys: [
          "images (Array von Image-URLs, ideale Größe 230×129 px)",
          "count (gleichzeitig sichtbare Bilder, default 30)",
          "bg_color (white, light, dark – default dark)",
          "logo_url (URL zum Logo-Bild, optional)",
          "logo_width (Breite des Logos in px, default 160)",
          "title (Titel unter Logo, optional)",
          "overlay_top (Abstand des Overlays von oben in %, default 35)",
          "logo_gap (Abstand zwischen Logo und Text in rem, default 3)",
          "subtitle (Untertitel unter Title, optional)",
          "button_text (1. Button-Beschriftung, optional)",
          "button_link (1. Button-Ziel-URL, optional)",
          "button2_text (2. Button-Beschriftung, optional)",
          "button2_link (2. Button-Ziel-URL, optional)"
        ],
        example: {
          images: [
            "/images/teaser/project1.jpg",
            "/images/teaser/project2.jpg",
            "/images/teaser/project3.jpg"
          ],
          count: 30,
          bg_color: "dark",
          logo_url: "/images/logo-white.svg",
          logo_width: 160,
          title: "SEARCH | APPLY | CREATE | CONNECT",
          overlay_top: 35,
          logo_gap: 3,
          subtitle: "Wissen sichtbar machen. Zusammenarbeit stärken.",
          button_text: "Mehr erfahren",
          button_link: "/features",
          button2_text: "Jetzt starten",
          button2_link: "/kontakt"
        }
      },
      accordion_tabs_section: {
        keys: [
          "tabs (Array mit 4 Tabs - optional, Defaults vorhanden)",
          "tabs[].name (z.B. SEARCH, APPLY, CREATE, CONNECT)",
          "tabs[].icon (Asset-Pfad z.B. icons/search.svg)",
          "tabs[].color (optional, Hex-Farbe für Tab-Name z.B. #3b82f6)",
          "bg_color (white, light, dark - default dark)",
          "container (contained, narrow, full – default contained)",
          "tab_height (rem, feste Höhe des Tab-Inhaltsbereichs, default 22)",
          "padding_top (rem, default 4)",
          "padding_bottom (rem, default 4)",
          "Body Tab 1 (ActionText)",
          "Body Tab 2 (ActionText)",
          "Body Tab 3 (ActionText)",
          "Body Tab 4 (ActionText)"
        ],
        example: {
          tabs: [
            { name: "SEARCH", icon: "icons/search.svg", color: "#3b82f6" },
            { name: "APPLY",  icon: "icons/apply.svg" },
            { name: "CREATE", icon: "icons/create.svg" },
            { name: "CONNECT", icon: "icons/connect.svg" }
          ],
          bg_color: "dark",
          container: "contained",
          tab_height: "22",
          padding_top: "4",
          padding_bottom: "4"
        },
      },
    }
  }

  toast(message) {
    if (!this.hasFlashTarget) return
    this.flashTarget.textContent = message
    this.flashTarget.classList.remove("hidden")
    clearTimeout(this._t)
    this._t = setTimeout(() => this.flashTarget.classList.add("hidden"), 1800)
  }

  emptyState() {
    return '<div class="rounded-xl border bg-amber-50 p-4 text-amber-900">' +
      '<p class="text-sm font-semibold">Settings Cheatsheet</p>' +
      '<p class="mt-1 text-xs">Choose a template kind to see the expected JSON structure.</p>' +
    '</div>'
  }

  humanJsonError(e) {
    const msg = e && e.message ? e.message : "Parse error"
    return msg.length > 120 ? msg.slice(0, 120) + "..." : msg
  }

  escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;")
  }
}
